import React from 'react';
import clsx from 'clsx';
import RowElement from './RowElement';
import InputDataComponent from './InputDataComponent';
import LabelDataComponent from './LabelDataComponent';
import CheckboxDataComponent from './CheckboxDataComponent';
import SummaryRow from './SummaryRow';
import TextareaDataComponent from './TextareaDataComponent';
import ButtonDataComponent from './ButtonDataComponent';
import DropdownDataComponent from './DropdownDataComponent';
import RadioDataComponent from './RadioDataComponent';
import AddInsideComponent from './AddInsideComponent'

/**
 * @param {[][]} props.typeFields - 2d array which contains for every row of a form the types of the inside components  
 * @param {setState} props.setTypeFields - hook method that handle typeFields variable
 * @param {[][]} props.component - 2d array  which contains for every row of a form the inside components
 * @param {setState} props.setComponents - hook method that handle components variable 
 * @param {number} props.formRowIndex - index of examined row of a form
 * @param {boolean} props.clickedChangeElement - variable that is used to render components inside form data element again
 * @param {setState} props.setClickedChangeElement - hook method that handle clickedChangeElement variable
 * @param {boolean} props.openAlert - state that opens/closes edit form pop up 
 * @returns form row component inside edit form data element pop up
 */
const FormRow = (props) => {

    const {
        typeFields,
        setTypeFields,
        components,
        setComponents,
        formRowIndex,
        clickedChangeElement,
        setClickedChangeElement,
        openAlert
    } = props;

    const [displayContent, setDisplayContent] = React.useState(false); // state that renders/hides content below form row

    // Delete form row function
    const deleteElement = () =>{
        
        // Delete row that coresponds to form row from typeFields
        const tempTypeFields = [...typeFields];
        tempTypeFields.splice(formRowIndex,1);
        setTypeFields(tempTypeFields);

        // Delete row that coresponds to form row from components 
        const tempComponents = [...components];
        tempComponents.splice(formRowIndex,1);
        setComponents(tempComponents);

        setClickedChangeElement(true); // set clickedChangeElement to true in order to rerender components again

    }

    return(
            <div style={{marginTop: '1vw'}}>

                <RowElement
                    label = {`Row ${(formRowIndex+1)}`}
                    displayContent={displayContent}
                    setDisplayContent={setDisplayContent}
                    deleteElement={deleteElement}
                />
                <div className={clsx('spacingTopDiv', 'spacingLeftDiv')} style={displayContent !== true ? {display: 'none'}: {display: 'inherit'} }>
                    <SummaryRow
                        infoRow={components[formRowIndex]}
                        componentsRow={typeFields[formRowIndex]}
                        formRowIndex={formRowIndex}
                    />
                    {typeFields[formRowIndex].map( (type,indexComponent) => 
                        
                        {
                            if(type === 'input'){
                                return(
                                        <InputDataComponent
                                            components={components}
                                            setComponents={setComponents}
                                            typeFields={typeFields}
                                            setTypeFields={setTypeFields}
                                            formRowIndex={formRowIndex}
                                            indexComponent={indexComponent}
                                            clickedChangeElement={clickedChangeElement}
                                            setClickedChangeElement={setClickedChangeElement}
                                            openAlert={openAlert}
                                        />    
                                )
                            }
                            if( type === 'label'){
                                return(
                                        <LabelDataComponent
                                            components={components}
                                            setComponents={setComponents}
                                            typeFields={typeFields}
                                            setTypeFields={setTypeFields}
                                            formRowIndex={formRowIndex}
                                            indexComponent={indexComponent}
                                            clickedChangeElement={clickedChangeElement}
                                            setClickedChangeElement={setClickedChangeElement}
                                            openAlert={openAlert}
                                        />
                                )
                            }
                            if( type === 'checkbox'){
                                return(
                                    <CheckboxDataComponent
                                        components={components}
                                        setComponents={setComponents}
                                        typeFields={typeFields}
                                        setTypeFields={setTypeFields}
                                        formRowIndex={formRowIndex}
                                        indexComponent={indexComponent}
                                        setClickedChangeElement={setClickedChangeElement}
                                    />
                                )
                            }
                            if( type === 'textarea'){
                                return(
                                    <TextareaDataComponent
                                        components={components}
                                        setComponents={setComponents}
                                        typeFields={typeFields}
                                        setTypeFields={setTypeFields}
                                        formRowIndex={formRowIndex}
                                        indexComponent={indexComponent}
                                        clickedChangeElement={clickedChangeElement}
                                        setClickedChangeElement={setClickedChangeElement}
                                        openAlert={openAlert}
                                    />
                                )
                            }
                            if( type === 'button'){
                                return(
                                    <ButtonDataComponent
                                        components={components}
                                        setComponents={setComponents}
                                        typeFields={typeFields}
                                        setTypeFields={setTypeFields}
                                        formRowIndex={formRowIndex}
                                        indexComponent={indexComponent}
                                        clickedChangeElement={clickedChangeElement}
                                        setClickedChangeElement={setClickedChangeElement}
                                        openAlert={openAlert}
                                    />
                                )
                            }
                            if( type === 'dropdown'){
                                return(
                                    <DropdownDataComponent
                                        components={components}
                                        setComponents={setComponents}
                                        typeFields={typeFields}
                                        setTypeFields={setTypeFields}
                                        formRowIndex={formRowIndex}
                                        indexComponent={indexComponent}
                                        clickedChangeElement={clickedChangeElement}
                                        setClickedChangeElement={setClickedChangeElement}
                                        openAlert={openAlert}
                                    />
                                )
                            }
                            if(type === 'radio'){
                                return(
                                    <RadioDataComponent
                                        components={components}
                                        setComponents={setComponents}
                                        typeFields={typeFields}
                                        setTypeFields={setTypeFields}
                                        formRowIndex={formRowIndex}
                                        indexComponent={indexComponent}
                                        setClickedChangeElement={setClickedChangeElement}
                                    /> 
                                )
                            }
                            return '';

                        }

                    )    
                    }
                <AddInsideComponent
                    components = {components}
                    setComponents = {setComponents}
                    typeFields = {typeFields}
                    setTypeFields = {setTypeFields}
                    formRowIndex={formRowIndex}
                />
                </div>
            </div>
    )

}

export default FormRow;